<template>
  <div class="fdle-wrap">

    <!-- Toolbar -->
    <div class="fdle-toolbar">
      <div class="toolbar-left">
        <div class="field-group">
          <label>Apply Default Markup ($)</label>
          <div class="num-input-wrap">
            <span class="num-prefix">$</span>
            <input
              type="number" min="0"
              class="num-input"
              placeholder="e.g. 5.00"
              v-model="set_default_markup"
              @keyup="checkMarkupAllResult_()"
            />
          </div>
        </div>
        <div class="field-group">
          <label>Apply Default Tax (%)</label>
          <div class="num-input-wrap">
            <span class="num-prefix">%</span>
            <input
              type="number" min="0"
              class="num-input"
              placeholder="e.g. 10"
              v-model="set_default_tax"
              @keyup="checkTaxAllResult_()"
            />
          </div>
        </div>
      </div>
      <button class="btn-refresh" @click="Refresh()">
        <i class="fa fa-sync-alt"></i> Refresh
      </button>
    </div>

    <!-- Loading -->
    <div class="state-box" v-if="loadingData">
      <i class="fa fa-spinner fa-spin"></i> Loading…
    </div>

    <!-- Empty -->
    <div class="state-box" v-else-if="!loadingData && table_datas.length === 0">
      <i class="fa fa-table"></i> No ORI data found
    </div>

    <!-- Table -->
    <div class="table-scroll" v-else>
      <table class="fdle-table">
        <thead>
          <tr class="group-row">
            <th class="g-blank" rowspan="1"></th>
            <th class="g-ref" colspan="2">Reference</th>
            <th class="g-custom" colspan="1">Custom</th>
            <th class="g-calc" colspan="1">Calculated</th>
            <th class="g-ref" colspan="1">Ref. Tax</th>
            <th class="g-custom" colspan="1">Custom</th>
            <th class="g-calc" colspan="1">Final</th>
          </tr>
          <tr class="col-headers">
            <th class="th-plain" style="min-width:140px;">ORI</th>
            <th class="th-ref">Cost ($)</th>
            <th class="th-ref">Def. Markup ($)</th>
            <th class="th-cus" style="width:120px;">Markup ($)</th>
            <th class="th-calc">Sub Total ($)</th>
            <th class="th-ref">Def. Tax (%)</th>
            <th class="th-cus" style="width:110px;">Tax (%)</th>
            <th class="th-calc">Sell Price ($)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in table_datas" :key="index">
            <td class="td-ori">{{ data.service_ori }}</td>
            <td class="td-ref">{{ data.our_rate }}</td>
            <td class="td-ref">{{ client.default_markup }}</td>
            <td class="td-cus">
              <div class="input-wrap">
                <span class="ip">$</span>
                <input class="rate-input" type="number" min="0"
                  v-model="data.markup" @keyup="changemarkup(index)" placeholder="0.00" />
              </div>
            </td>
            <td class="td-calc">{{ data.sub_total }}</td>
            <td class="td-ref">{{ client.default_tax }}</td>
            <td class="td-cus">
              <div class="input-wrap">
                <span class="ip">%</span>
                <input class="rate-input" type="number" min="0"
                  v-model="data.tax_percentage" @keyup="changetaxpercentage(index)" placeholder="0" />
              </div>
            </td>
            <td class="td-calc sell">{{ data.selling_price }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Save bar -->
    <div class="save-bar" v-if="!loadingData && table_datas.length > 0">
      <div class="save-bar__inner">
        <span class="save-bar__info">
          {{ client.name ? client.name + ' — Florida Rates' : 'Florida Rates' }}
        </span>
        <button class="btn-save" ref="kt_save_service" @click="update('S', 'kt_save_service')">
          <i class="fa fa-check"></i> Save Rates
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  FETCH_FLORIDA_SERVICEORI,
  FETCH_SP_ORI_RATE_LISTS,
  UPDATE_SP_ORI_RATE_LISTS
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      table_datas: [],
      errors: [],
      loadingData: false,
      serviceError: "",
      client: {},
      set_default_tax: "",
      set_default_markup: "",
      checkallmarkup: false,
      checkalltax: false
    };
  },
  computed: {
    ...mapGetters(["getServiceOriData"])
  },
  created() {
    this.getServiceData();
  },
  methods: {
    getServiceData() {
      this.loadingData = true;
      this.table_datas = [];
      const data_ = { id: this.$route.params.id, code: "fdle" };
      this.$store.dispatch(FETCH_FLORIDA_SERVICEORI)
        .then(data_service => {
          this.$store.dispatch(FETCH_SP_ORI_RATE_LISTS, data_)
            .then(data => {
              this.client = data.client;
              this.set_default_markup = this.client.default_markup;
              this.set_default_tax = this.client.default_tax;
              if (!this.client.default_markup) this.client.default_markup = this.client.sp_default_rate;
              if (!this.client.default_tax)    this.client.default_tax    = this.client.sp_default_tax;
              data_service.data.forEach(service_ori => {
                const key = data.rates.findIndex(x => x.service_ori.id === service_ori.id);
                if (key === -1) {
                  const our_rate      = parseFloat(service_ori.our_rate || 0);
                  const def_markup    = parseFloat(this.client.default_markup || 0);
                  const def_tax       = parseFloat(this.client.default_tax || 0);
                  const sub_total     = our_rate + def_markup;
                  const selling_price = (sub_total + (sub_total * def_tax) / 100).toFixed(2);
                  this.table_datas.push({ id: service_ori.id, service_ori: service_ori.ori_number, our_rate: service_ori.our_rate, sub_total, markup: "", selling_price, tax_percentage: "" });
                } else {
                  const r = data.rates[key];
                  this.table_datas.push({ id: service_ori.id, service_ori: service_ori.ori_number, our_rate: r.cost, sub_total: r.sub_total, markup: r.markup, selling_price: r.selling_price, tax_percentage: r.tax_percentage });
                }
              });
              this.loadingData = false;
            })
            .catch(() => { this.loadingData = false; });
        })
        .catch(() => { this.loadingData = false; });
    },
    checkMarkupAllResult_() {
      const def_markup = this.set_default_markup !== "" ? parseFloat(this.set_default_markup) : parseFloat(this.client.default_markup || 0);
      this.table_datas.forEach(el => {
        const cost    = parseFloat(el.our_rate || 0);
        const markup  = this.set_default_markup !== "" ? def_markup : (el.markup !== "" ? parseFloat(el.markup) : def_markup);
        const tax     = el.tax_percentage !== "" ? parseFloat(el.tax_percentage) : parseFloat(this.client.default_tax || 0);
        el.markup     = this.set_default_markup !== "" ? def_markup : el.markup;
        el.sub_total  = cost + markup;
        el.selling_price = parseFloat(cost + markup + ((cost + markup) * tax) / 100).toFixed(2);
      });
    },
    checkTaxAllResult_() {
      const def_tax = this.set_default_tax !== "" ? parseFloat(this.set_default_tax) : parseFloat(this.client.default_tax || 0);
      this.table_datas.forEach(el => {
        const cost   = parseFloat(el.our_rate || 0);
        const markup = el.markup !== "" ? parseFloat(el.markup) : parseFloat(this.client.default_markup || 0);
        const tax    = this.set_default_tax !== "" ? def_tax : (el.tax_percentage !== "" ? parseFloat(el.tax_percentage) : def_tax);
        el.tax_percentage   = this.set_default_tax !== "" ? def_tax : el.tax_percentage;
        el.sub_total        = cost + markup;
        el.selling_price    = parseFloat(cost + markup + ((cost + markup) * tax) / 100).toFixed(2);
      });
    },
    changemarkup(index) {
      const el         = this.table_datas[index];
      const cost       = parseFloat(el.our_rate || 0);
      const def_markup = parseFloat(this.client.default_markup || 0);
      const markup     = el.markup !== "" ? parseFloat(el.markup) : def_markup;
      const tax        = el.tax_percentage !== "" ? parseFloat(el.tax_percentage) : parseFloat(this.client.default_tax || 0);
      el.sub_total     = cost + markup;
      el.selling_price = parseFloat(cost + markup + ((cost + markup) * tax) / 100).toFixed(2);
    },
    changetaxpercentage(index) {
      const el         = this.table_datas[index];
      const cost       = parseFloat(el.our_rate || 0);
      const def_markup = parseFloat(this.client.default_markup || 0);
      const markup     = el.markup !== "" ? parseFloat(el.markup) : def_markup;
      const tax        = el.tax_percentage !== "" ? parseFloat(el.tax_percentage) : parseFloat(this.client.default_tax || 0);
      el.sub_total     = cost + markup;
      el.selling_price = parseFloat(cost + markup + ((cost + markup) * tax) / 100).toFixed(2);
    },
    Refresh() {
      this.set_default_markup = "";
      this.set_default_tax    = "";
      this.table_datas        = [];
      this.getServiceData();
    },
    closeBtnLoad(ref) { const b = this.$refs[ref]; if (b) b.disabled = false; },
    loadingButton(ref) { const b = this.$refs[ref]; if (b) b.disabled = true; },
    update(_saveType, ref) {
      this.loadingButton(ref);
      const _data = {
        location_id:  this.$route.params.id,
        code:         this.client.service_type,
        default_rate: this.set_default_markup,
        default_tax:  this.set_default_tax,
        rate_list:    this.table_datas
      };
      this.$store.dispatch(UPDATE_SP_ORI_RATE_LISTS, _data)
        .then(data => { this.$toastr.s(data.msg); this.closeBtnLoad(ref); this.getServiceData(); })
        .catch(err => { this.errors = err; this.getServiceData(); this.closeBtnLoad(ref); });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:  'Segoe UI', sans-serif;
$blue:  #389ad4;
$dark:  #0d1b3e;
$green: #276749;
$border: #dde2ec;

/* ── Toolbar ── */
.fdle-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f3fa;
  gap: 12px;
  flex-wrap: wrap;

  .toolbar-left {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
  }

  .field-group {
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      color: #7a8499;
    }
  }

  .num-input-wrap {
    display: flex;
    align-items: center;
    height: 36px;
    border: 1.5px solid $border;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    width: 160px;
    transition: border-color 0.15s;

    &:focus-within { border-color: $blue; }

    .num-prefix {
      height: 100%;
      padding: 0 8px;
      background: #f5f7fa;
      border-right: 1px solid #e2e8f0;
      color: #a0aab8;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
    }

    .num-input {
      flex: 1;
      border: none;
      outline: none;
      padding: 0 8px;
      font-size: 13px;
      color: $dark;
      font-family: $font;
      background: transparent;

      &[type=number] { -moz-appearance: textfield; appearance: textfield; }
      &::-webkit-outer-spin-button, &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
    }
  }

  .btn-refresh {
    height: 36px;
    padding: 0 16px;
    border-radius: 8px;
    border: 1.5px solid $border;
    background: #fff;
    color: #4a5568;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.15s;

    &:hover { border-color: $blue; color: $blue; }
  }
}

/* ── Table ── */
.table-scroll {
  overflow-x: auto;
  max-height: calc(100vh - 280px);
  overflow-y: auto;
}

.fdle-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
  font-family: $font;
  min-width: 780px;

  /* Group row */
  .group-row th {
    padding: 8px 10px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #eef0f8;
    text-align: center;
    position: sticky;
    top: 0;
    z-index: 5;

    &.g-blank   { background: #fafbfd; }
    &.g-ref     { background: #f0f4fa; color: #4a5568; border-left: 2px solid #c5d4f0; border-right: 2px solid #c5d4f0; }
    &.g-custom  { background: #f0fdf4; color: $green;  border-left: 2px solid #b2dfcc; border-right: 2px solid #b2dfcc; }
    &.g-calc    { background: #f8f4ff; color: #6b46c1; border-left: 2px solid #ddd6fe; border-right: 2px solid #ddd6fe; }
  }

  /* Col headers */
  .col-headers th {
    padding: 7px 10px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    border-bottom: 2px solid #eef0f8;
    white-space: nowrap;
    text-align: right;
    position: sticky;
    top: 33px;
    z-index: 5;
    background: #fff;

    &.th-plain { text-align: left; background: #fff; }
    &.th-ref   { background: #f6f9fd !important; border-left: 2px solid #c5d4f0; border-right: 2px solid #c5d4f0; color: #7a8499; }
    &.th-cus   { background: #f6fdf9 !important; border-left: 2px solid #b2dfcc; border-right: 2px solid #b2dfcc; color: $green; }
    &.th-calc  { background: #faf8ff !important; border-left: 2px solid #ddd6fe; border-right: 2px solid #ddd6fe; color: #6b46c1; }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.12s;

    &:last-child { border-bottom: none; }
    &:hover { background: #f8fbff; }

    td {
      padding: 8px 10px;
      vertical-align: middle;
      text-align: right;
    }

    .td-ori   { text-align: left; font-weight: 600; color: $dark; font-size: 12px; }
    .td-ref   { color: #7a8499; font-family: monospace; background: #f8fafd; border-left: 1px solid #e8edf5; border-right: 1px solid #e8edf5; }
    .td-cus   { background: #f7fdf9; border-left: 1px solid #e0f5eb; border-right: 1px solid #e0f5eb; padding: 6px 8px; }
    .td-calc  { color: #6b46c1; font-weight: 600; font-family: monospace; background: #faf8ff; border-left: 1px solid #ede9fe; border-right: 1px solid #ede9fe; }
    .sell     { font-size: 13px; }
  }
}

/* ── Input cell ── */
.input-wrap {
  display: flex;
  align-items: center;
  height: 28px;
  border: 1.5px solid $border;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.15s;

  &:focus-within { border-color: $blue; box-shadow: 0 0 0 2px rgba(56,154,212,0.1); }

  .ip {
    height: 100%;
    padding: 0 5px 0 7px;
    background: #f5f7fa;
    border-right: 1px solid #e2e8f0;
    color: #a0aab8;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    user-select: none;
  }

  .rate-input {
    flex: 1;
    border: none;
    outline: none;
    height: 100%;
    padding: 0 6px;
    font-size: 12px;
    color: $dark;
    font-family: $font;
    background: transparent;
    text-align: right;
    min-width: 0;

    &[type=number] { -moz-appearance: textfield; appearance: textfield; }
    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  }
}

/* ── States ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* ── Save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  z-index: 200;

  .save-bar__inner {
    background: $dark;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(13,27,62,0.3);
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .save-bar__info {
      font-size: 13px;
      color: rgba(255,255,255,0.75);
      font-family: $font;
    }

    .btn-save {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      height: 36px;
      padding: 0 22px;
      background: $green;
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      font-family: $font;
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover { opacity: 0.9; }
      &:disabled { opacity: 0.55; cursor: not-allowed; }
    }
  }
}
</style>
